import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import PayslipPDFDocumentURL from "../model/PayslipPDFDocumentURL";

const DocumentProcessingJobDetailsApiService = async (
  request: number
): Promise<PayslipPDFDocumentURL> => {
  const url = `/payslip_documents/${request}/signed_url/`;
  const { data } = await axios.get(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useDocumentProcessingJobDetailsApiService = (request: number) =>
  useQuery<Promise<PayslipPDFDocumentURL>, AxiosError, PayslipPDFDocumentURL>(
    ["DocumentProcessingJobDetailsApiService", request],
    () => DocumentProcessingJobDetailsApiService(request)
  );

export default useDocumentProcessingJobDetailsApiService;
